import styled from 'styled-components';
import { rem } from 'polished';
import { ProgressiveImg } from '~helpers';
var ItemImage = styled(ProgressiveImg).attrs(function (_ref) {
  var height = _ref.height,
      width = _ref.width;
  return {
    height: height,
    width: width
  };
}).withConfig({
  displayName: "ItemImage",
  componentId: "xq2ftw-0"
})(["height:", ";width:", ";"], function (_ref2) {
  var height = _ref2.height;
  return rem(height);
}, function (_ref3) {
  var width = _ref3.width;
  return rem(width);
});
export default ItemImage;